<template>
  <b-row class="my-3">
    <b-col lg="3" md="3" >
      <slot name="pr-1"/>
    </b-col>

    <b-col lg="6" md="6" >
      <slot name="p-1"/>
    </b-col>

    <b-col lg="3" md="3" class=" text-center align-self-center ">
      <slot name="pl-1"/>
    </b-col>

  </b-row>
</template>

<script>
export default {
  name: "Card300"
}
</script>

<style scoped>

</style>